import React from 'react';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import dayjs from 'dayjs';

function ExportExcel(props) {
  const { filename, companiesDataSet } = props;

  const [data, setData] = React.useState({});

  const exporter = React.useRef();

  const exportExcelFunction = () => {
    if (exporter.current) {
      exporter.current.save();
    }
  };

  React.useEffect(() => {
    const temp = (companiesDataSet || []).reduce((acc, element) => {
      const data = { ...element };
      data.Status = element.Status ? 'Activa' : 'Inactiva';
      data.carrer = !element.carrer ? 'Indiferente' : element.carrer.toString();
      data.postedFrom = element.postedFrom
        ? dayjs(element.postedFrom).format('DD / MM / YYYY')
        : element.createdAt
        ? dayjs(element.createdAt).format('DD / MM / YYYY')
        : 'Sin registro';
      data.ATS = element.ATS ? 'Si' : 'No';
      acc.push(data);
      return acc;
    }, []);
    setData(temp);
  }, [companiesDataSet]);

  return (
    <>
      <button type="button" className="k-button k-primary" onClick={exportExcelFunction}>
        Exportar a Excel
      </button>
      <ExcelExport data={data} fileName={`${filename}.xlsx`} ref={exporter}>
        <ExcelExportColumn title="Estatus" field="Status" />
        <ExcelExportColumn title="Nombre" field="jobTitle" />
        <ExcelExportColumn title="Empresa" field="companyName" />
        <ExcelExportColumn title="Rango de salario" field="jobPay" />
        <ExcelExportColumn title="Carrera(s)" field="carrer" />
        <ExcelExportColumn title="Seniority" field="seniority" />
        <ExcelExportColumn title="Contrato" field="contract" />
        <ExcelExportColumn title="Ubicación" field="locationName" />
        <ExcelExportColumn title="# Aplicantes" field="applicantsCount" />
        <ExcelExportColumn title="Fecha de publicación" field="postedFrom" />
        <ExcelExportColumn title="Externa" field="ATS" />
      </ExcelExport>
    </>
  );
}

export default ExportExcel;
